// extracted by css-extract-rspack-plugin
export default {"wrapperInner":"Schedule_wrapperInner__VZxhM","root":"Schedule_root__EY3ha","note":"Schedule_note__XFEQm"};